// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-title[data-v-b0882c10] {\n  font-size: 16px;\n  height: 20px;\n  line-height: 20px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
